import {
  CopilotInfo,
  createCopilotRegistry,
  getGlobalCopilotRegistry,
} from "@zapier/ai-toolkit";

// Get AI toolkit demos base URL for additional copilots
export const getAiToolkitBaseUrl = () => {
  if (process.env.NODE_ENV === "development") {
    // Use env var for dev port, fallback to 3000
    const aiToolkitPort = process.env.NEXT_PUBLIC_AI_TOOLKIT_PORT || "3000";
    const url = `http://localhost:${aiToolkitPort}`;
    return url;
  }
  return "https://ai-toolkit.vercel.zapier.com";
};

// Additional copilots to extend the global registry
export const additionalCopilots = [] satisfies readonly CopilotInfo[];

/**
 * Get Canvas copilot registry that extends the global registry
 * with additional Canvas-specific copilots (search, deep-consult)
 */
export const getCanvasCopilotRegistry = async () => {
  const globalRegistry = await getGlobalCopilotRegistry();

  // Combine global copilots with additional ones
  const allCopilots = [
    ...globalRegistry.copilots,
    ...additionalCopilots,
  ] as readonly CopilotInfo[];

  const registry = createCopilotRegistry(allCopilots);

  return registry;
};
